import { Brand } from "types/common";

export const DEFAULT_IMAGE_HOST = "cdn.media.amplience.net";
export const FACET_UPDATE_EVENT = "plp/facet-update";
export const GRID_UPDATE_EVENT = "plp/grid-update";
export const PLP_ROOT_ID = "product-listing-root";
export const SEARCH_PLP_ROOT_ID = "search-plp-root";
export const BROWSE_PLP_ROOT_ID = "browse-plp-root";
export const PROMO_PLP_ROOT_ID = "promo-plp-root";

export const PLP_ROOT_IDS = [PLP_ROOT_ID, SEARCH_PLP_ROOT_ID, BROWSE_PLP_ROOT_ID, PROMO_PLP_ROOT_ID];
export const BRAND_IMAGE_HOSTS_MAP = {
  [Brand.Very]: "media.very.co.uk",
  [Brand.VeryIE]: "media.very.ie",
  [Brand.Littlewoods]: "media.littlewoods.com",
};
